(function() {
  var rootSelector = '[class*="tz-master-grid-"]';
  var revealSelectors = [
    '[class*="tz-proof-align-"]',
    '[class*="tz-price-wrap-"]',
    '[class*="tz-payment-row-grid-"]',
    '[class*="tz-payment-node-card-"]',
    '[class*="tz-gift-block-"]',
    '[class*="tz-bundle-block-"]',
    '[class*="tz-bulk-block-"]',
      '[class*="tz-smart-reels-"]',
    '[class*="tz-clean-desc-"]',
    '[class*="tz-pickup-box-"]',
    '[class*="tz-tax-note-"]',
    '.tz-tabs-legacy-wrap',
    '.tz-premium-info-tabs-card',
    '.tz-apart-block-wrapper',
    '[data-tz-discount-banner]'
  ];
  var staggerSelectors = [
    '[class*="tz-bundle-item-card"]',
    '.tz-bundle-checkbox-line',
    '[class*="tz-bulk-option-"]',
    '[class*="tz-smart-reel-card-"]',
    '.tz-premium-review-card-item',
    '.tz-apart-why-card-node-item',
    '.tz-apart-promise-card-node-item'
  ];

  function markNode(node, type, delay) {
    if (!node || node.nodeType !== 1) return;
    if (!node.hasAttribute('data-tz-reveal')) node.setAttribute('data-tz-reveal', type || 'up');
    if (typeof delay === 'number') node.style.setProperty('--tz-reveal-delay', Math.min(delay, 280) + 'ms');
  }

  function queryAllSafe(root, selector) {
    try {
      return Array.prototype.slice.call(root.querySelectorAll(selector));
    } catch (error) {
      return [];
    }
  }

  function markMainBlockChildren(root) {
    var productRow = root.closest('.product__row') || root;
    var candidates = Array.prototype.slice.call(productRow.children || []);
    candidates.forEach(function(node, index) {
      if (!node || node.id === 'custom-css-global-injector-node') return;
      if (node.offsetParent === null && !node.getClientRects().length) return;
      markNode(node, 'up', (index % 4) * 55);
    });
  }

  function applyReveal(root) {
    if (!root || root.getAttribute('data-tz-scroll-ready') === 'true') return;
    root.setAttribute('data-tz-scroll-ready', 'true');

    revealSelectors.forEach(function(selector) {
      queryAllSafe(root, selector).forEach(function(node, index) {
        markNode(node, 'up', (index % 4) * 45);
      });
    });

    staggerSelectors.forEach(function(selector) {
      queryAllSafe(root, selector).forEach(function(node, index) {
        markNode(node, 'up', index * 70);
      });
    });

    markMainBlockChildren(root);
  }

  function revealNow(nodes) {
    nodes.forEach(function(node) {
      node.classList.add('tz-reveal-in');
    });
  }

  function initScrollTopHanger() {
    if (document.querySelector('[data-tz-scroll-top-hanger]')) return;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'tz-scroll-top-hanger';
    button.setAttribute('data-tz-scroll-top-hanger', '');
    button.setAttribute('aria-label', 'Back to top. Page scrolled 0%.');
    button.innerHTML = '<span class="tz-scroll-top-arrow" aria-hidden="true">↑</span><small class="tz-scroll-top-percent">0%</small>';
    document.body.appendChild(button);

    var percentNode = button.querySelector('.tz-scroll-top-percent');
    var ticking = false;

    function update() {
      ticking = false;
      var doc = document.documentElement;
      var body = document.body;
      var scrollTop = window.pageYOffset || doc.scrollTop || body.scrollTop || 0;
      var scrollable = Math.max(1, (doc.scrollHeight || body.scrollHeight || 1) - window.innerHeight);
      var percent = Math.max(0, Math.min(100, Math.round((scrollTop / scrollable) * 100)));
      var degrees = Math.round((percent / 100) * 360);

      button.style.setProperty('--tz-scroll-progress', degrees + 'deg');
      button.classList.toggle('is-visible', scrollTop > 180 && percent > 3);
      button.classList.toggle('is-complete', percent > 94);
      if (percentNode) percentNode.textContent = percent + '%';
      button.setAttribute('aria-label', 'Back to top. Page scrolled ' + percent + '%.');
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    button.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    update();
  }

  function isVisibleTarget(node) {
    if (!node || node.nodeType !== 1) return false;
    var rect = node.getBoundingClientRect();
    var style = window.getComputedStyle(node);
    return rect.width > 8 && rect.height > 8 && style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity || 1) > 0.05;
  }

  function getCenter(rect) {
    return {
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2
    };
  }

  function getPreferredCenter(node) {
    if (!node) return null;
    var icon = node.querySelector && node.querySelector('.tz-mobile-nav__icon, svg, img, [data-tz-cart-count]');
    return getCenter((icon && isVisibleTarget(icon) ? icon : node).getBoundingClientRect());
  }

  function firstVisibleFromSelectors(selectors) {
    var found = null;
    selectors.some(function(selector) {
      return queryAllSafe(document, selector).some(function(node) {
        if (!isVisibleTarget(node)) return false;
        found = node;
        return true;
      });
    });
    return found;
  }

  function findCartTarget(sourcePoint) {
    var mobileNavSelectors = [
      '[data-tz-mobile-nav] [data-nav-type="cart"]',
      '.tz-mobile-nav [data-nav-type="cart"]',
      '[data-nav-type="cart"]',
      '.tz-mobile-nav__item[data-nav-type="cart"]',
      '.tz-mobile-nav__button[data-nav-type="cart"]'
    ];
    var boosterSelectors = [
      '.page__header--mobile .minicart__label',
      '.page__header--mobile label.minicart__label',
      '.page__header--mobile .minicart__button .minicart__label',
      '.minicart__button .minicart__label',
      '.minicart__label',
      '.header__icon--cart',
      '#cart-icon-bubble'
    ];
    var fallbackSelectors = [
      '[data-cart-toggle]',
      '[data-cart-drawer-toggle]',
      '[data-cart-drawer-trigger]',
      'button[aria-controls*="CartDrawer"]',
      '[aria-controls="CartDrawer"]',
      '[data-tz-cart]',
      '[data-tz-mobile-nav] a[href*="/cart"]',
      '[data-tz-mobile-nav] button[data-cart]',
      'button[aria-label*="cart" i]',
      'button[title*="cart" i]',
      '[aria-label*="cart" i]',
      '[title*="cart" i]',
      '.cart-icon',
      '.cart__icon',
      '.header__cart',
      'a[href*="/cart"]'
    ];
    var preferred = firstVisibleFromSelectors(mobileNavSelectors) || firstVisibleFromSelectors(boosterSelectors) || firstVisibleFromSelectors(fallbackSelectors);

    if (!preferred) {
      return {
        point: {
          x: window.innerWidth - 34,
          y: Math.max(34, window.innerHeight * 0.18)
        },
        node: null
      };
    }

    return {
      point: getPreferredCenter(preferred),
      node: preferred
    };
  }

  function fireCartStar(sourceButton) {
    if (!sourceButton || !isVisibleTarget(sourceButton)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var sourceRect = sourceButton.getBoundingClientRect();
    var sourcePoint = getCenter(sourceRect);
    var targetInfo = findCartTarget(sourcePoint);
    var targetPoint = targetInfo.point;
    var star = document.createElement('span');
    var dx = Math.round(targetPoint.x - sourcePoint.x);
    var dy = Math.round(targetPoint.y - sourcePoint.y);
    var distance = Math.max(80, Math.hypot(dx, dy));
    var lift = Math.min(70, Math.max(24, distance * 0.12));
    var midX = Math.round(dx * 0.52);
    var midY = Math.round(dy * 0.52 - lift);

    star.className = 'tz-cart-fly-star';
    star.setAttribute('aria-hidden', 'true');
    star.style.left = sourcePoint.x + 'px';
    star.style.top = sourcePoint.y + 'px';
    star.style.setProperty('--tz-cart-fly-x', dx + 'px');
    star.style.setProperty('--tz-cart-fly-y', dy + 'px');
    star.style.setProperty('--tz-cart-fly-mid-x', midX + 'px');
    star.style.setProperty('--tz-cart-fly-mid-y', midY + 'px');
    star.innerHTML = '<span></span>';
    document.body.appendChild(star);

    window.setTimeout(function() {
      star.classList.add('is-flying');
    }, 16);

    window.setTimeout(function() {
      if (targetInfo.node) {
        targetInfo.node.classList.add('tz-cart-fly-impact');
        window.setTimeout(function() {
          targetInfo.node.classList.remove('tz-cart-fly-impact');
        }, 560);
      }
      if (star && star.parentNode) star.parentNode.removeChild(star);
    }, 980);
  }

  function initCartFlyStar() {
    if (document.documentElement.getAttribute('data-tz-cart-fly-ready') === 'true') return;
    document.documentElement.setAttribute('data-tz-cart-fly-ready', 'true');

    document.addEventListener('click', function(event) {
      var button = event.target.closest('#tz-master-atc-btn, #tz-mobile-atc-btn, #tz-add-bundle-btn, [data-tz-bulk-submit]');
      if (!button) return;
      fireCartStar(button);
    }, true);
  }

  function init() {
    var roots = Array.prototype.slice.call(document.querySelectorAll(rootSelector));
    if (!roots.length) roots = [document.body];
    roots.forEach(applyReveal);

    var nodes = Array.prototype.slice.call(document.querySelectorAll('[data-tz-reveal]'));
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      revealNow(nodes);
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('tz-reveal-in');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    nodes.forEach(function(node) {
      if (node.classList.contains('tz-reveal-in')) return;
      observer.observe(node);
    });
  }

  function boot() {
    init();
    initScrollTopHanger();
    initCartFlyStar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
